import React from 'react';

const Loading = () => {
    return (
        <div
            className='flex justify-center h-full fixed inset-0 !top-0 z-[1000] overflow-auto items-center bg-white bg-opacity-10 backdrop-blur-sm'
        >
            <div className="spinner relative">
                <div></div>
                <div className='bg-yellow-50'></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
}

export default Loading;